import { ComponentFactory, ComponentFactoryResolver, Injectable } from '@angular/core';

import { ProviderPayratesComponent } from './provider-payrates.component';

@Injectable({
    providedIn: 'root'
})
export class ProviderPayratesProvider {
    constructor(private resolver: ComponentFactoryResolver) {
        this.componentFactory = this.resolver.resolveComponentFactory(ProviderPayratesComponent);
    }
    componentFactory: ComponentFactory<unknown>;
}